import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/thank-you.webp'
import _imports_1 from '@/assets/icons/thank-you/PhoneIcon.svg'
import _imports_2 from '@/assets/icons/thank-you/TimeRewind.svg'
import _imports_3 from '@/assets/icons/thank-you/HomeLocation.svg'
import _imports_4 from '@/assets/icons/thank-you/AppStore.svg'
import _imports_5 from '@/assets/icons/thank-you/GoogleStore.svg'


_pushScopeId("data-v-c5929e0e")
const _hoisted_1 = { class: "thank-you" }
const _hoisted_2 = { class: "py-4" }
const _hoisted_3 = { class: "row mx-2 mx-mb-5" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "col-12 col-lg-4" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "Dziękujemy za kontakt",
    class: "thank-you-image mt-4"
  })
], -1)
const _hoisted_5 = { class: "col-12 col-lg-8 text-start" }
const _hoisted_6 = { class: "thank-you--header text-orange mt-4" }
const _hoisted_7 = { class: "mb-4 thank-you--subheader" }
const _hoisted_8 = { class: "d-flex align-items-center mb-3" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "mx-4" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: "phone"
  })
], -1)
const _hoisted_10 = { class: "text-orange" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode()
const _hoisted_12 = /*#__PURE__*/_createElementVNode("a", {
  href: "tel:603804805",
  class: "thank-you--phone"
}, "603 804 805", -1)
const _hoisted_13 = { class: "d-flex align-items-center mb-4" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "mx-4" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_2,
    alt: "time"
  })
], -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "text-nowrap text-orange" }, "8:00 - 19:00", -1)
const _hoisted_17 = { class: "app-section border-lg border-white rounded-custom mx-custom my-3 p-4 d-flex align-items-center justify-content-center flex-column" }
const _hoisted_18 = { class: "d-flex flex-column flex-md-row align-items-center justify-content-center mb-3" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("img", {
  class: "mb-3 mb-md-0",
  src: _imports_3,
  alt: "download"
}, null, -1)
const _hoisted_20 = { class: "ms-3 text-start thank-you--application__header fw-normal" }
const _hoisted_21 = { class: "text-orange fw-bold" }
const _hoisted_22 = /*#__PURE__*/_createTextVNode()
const _hoisted_23 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center justify-content-center flex-column flex-md-row" }, [
  /*#__PURE__*/_createElementVNode("a", { href: "https://apps.apple.com/hu/app/notu/id6446280619" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_4,
      alt: "appstore"
    })
  ]),
  /*#__PURE__*/_createElementVNode("a", { href: "https://play.google.com/store/apps/details?id=hu.realmonitor.app.android.aang" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_5,
      alt: "googleplay"
    })
  ])
], -1)
const _hoisted_25 = { class: "text-center mb-4" }
const _hoisted_26 = { class: "text-orange" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_29 = { class: "fw-normal" }
const _hoisted_30 = { class: "text-center py-4" }
const _hoisted_31 = {
  key: 0,
  class: "proposalid d-none"
}
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_notus_svg_icon = _resolveComponent("notus-svg-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("h2", _hoisted_6, _toDisplayString(_ctx.$t('page.contact.success.title')), 1),
          _createElementVNode("h3", _hoisted_7, _toDisplayString(_ctx.$t('page.contact.success.sub_title')), 1),
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _createElementVNode("div", null, [
              _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.$t('page.contact.success.call')), 1),
              _hoisted_11,
              _hoisted_12
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _hoisted_14,
            _createElementVNode("div", null, [
              _createTextVNode(_toDisplayString(_ctx.$t('page.contact.success.period')), 1),
              _hoisted_15,
              _createTextVNode(" " + _toDisplayString(_ctx.$t('page.contact.success.period_time')) + " ", 1),
              _hoisted_16
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("div", _hoisted_18, [
          _hoisted_19,
          _createElementVNode("h4", _hoisted_20, [
            _createTextVNode(_toDisplayString(_ctx.$t('page.contact.success.application_text_first')) + " ", 1),
            _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.$t('page.contact.success.application_text_second')), 1),
            _hoisted_22,
            _hoisted_23,
            _createTextVNode(" " + _toDisplayString(_ctx.$t('page.contact.success.application_text_third')), 1)
          ])
        ]),
        _hoisted_24
      ]),
      _createElementVNode("h3", _hoisted_25, [
        _createTextVNode(_toDisplayString(_ctx.$t('page.contact.success.footer_title_text_first')) + " ", 1),
        _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.$t('page.contact.success.footer_title_text_second')), 1),
        _hoisted_27,
        _hoisted_28,
        _createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.$t('page.contact.success.footer_sub_title')), 1)
      ]),
      _createElementVNode("div", _hoisted_30, [
        _createElementVNode("div", {
          class: "text-orange d-flex align-items-center justify-content-center flex-column fw-bold cursor-pointer",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$parent.scrollTop()))
        }, [
          _createTextVNode(_toDisplayString(_ctx.$t('page.contact.success.cta')) + " ", 1),
          _createVNode(_component_notus_svg_icon, {
            iconType: "chevron-down-orange",
            class: "chevron-down"
          })
        ])
      ]),
      (_ctx.proposalId)
        ? (_openBlock(), _createElementBlock("span", _hoisted_31, _toDisplayString(_ctx.proposalId), 1))
        : _createCommentVNode("", true)
    ])
  ]))
}